module.exports = __webpack_public_path__ + "lightBulb.png?091793c5ae0ea0edf44d278227d72541";